module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./web/fonts/fontawesome-webfont.ttf?v=4.1.0
// module id = 257
// module chunks = 0